import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FilterService } from 'src/app/services/filter/filter.service';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import { HttpInterceptorService } from 'src/app/services/http-interceptor/http-interceptor.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/variables';
import { FilterClass } from 'src/app/classes/filters';

const steps = [3.6, 11, 22, 43, 50];
const rangeSteps = [0, 1, 2, 3, 4];

@Component({
  selector: 'sc-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  @Input() fromMap: boolean = false;

  filters: FilterClass = new FilterClass();
  kWh: any;
  connectors: any = [];
  appConfig: AppConfig = new AppConfig();
  constructor(
    private alertCtrl: AlertController,
    private filterService: FilterService,
    private _http: HttpInterceptorService,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private navParams: NavParams
  ) {
    this.init();

    this.fromMap = this.navParams.get('fromMap');
  }
  ngOnInit() {
    this.init();
  }
  updateFilters() {
    //this.filterService.putFilters(this.filters);
  }
  resetFilters() {
    this.filters = new FilterClass();
    this.filterService.resetFilters();
    this.watchKWH(true);
    setTimeout(() => {
      this.init();
    }, 1000);
  }
  openAlert() {
    let inputs = [];

    for (let i = 0; i < this.connectors.length; i++) {
      inputs.push({
        id: this.connectors[i].IconName,
        type: 'checkbox',
        checked: this.isSelected(this.connectors[i].Name),
        label: this.connectors[i].Name,
        value: this.connectors[i].Name
      });
    }

    this.alertCtrl
      .create({
        header: this.translate.instant('FILTER.SELECT_CONNECTORS'),
        inputs: inputs,
        cssClass: 'connector-select',
        buttons: [
          {
            text: this.translate.instant('APP.CANCEL'),
            role: 'cancel'
          },
          {
            text: this.translate.instant('APP.OK'),
            handler: (selected) => {
              this.filters.connectors = selected;
            }
          }
        ]
      })
      .then((alert) => {
        alert.present();
      });
  }
  removeConnector(con) {
    let index = this.filters.connectors.indexOf(con);
    if (index > -1) {
      this.filters.connectors.splice(index, 1);
    }
  }
  watchKWH(init?: boolean) {
    //This function makes sure that the slider "snaps" to actual kW-values

    if (init) {
      this.kWh = {
        lower: this.getKWhIndex(this.filters.kWh.lower) || 0,
        upper: this.getKWhIndex(this.filters.kWh.upper) || steps.length
      };
    } else {
      this.filters.kWh.upper = steps[this.kWh.upper];
      this.filters.kWh.lower = steps[this.kWh.lower];
    }
  }
  getConnectors() {
    this._http.getUnsecure('CPConnectorTypes').subscribe((connectors) => {
      this.connectors = connectors;
    });
  }
  isSelected(conn) {
    return this.filters.connectors.includes(conn);
  }
  cancel() {
    this.filterService.putFilters(this.filters);
    this.modalCtrl.dismiss();
  }
  private init(reset?) {
    this.filterService.getFilters().then((filters) => {
      this.filters = new FilterClass();
      this.filters = filters;
      this.watchKWH(true); //Initializing the watcher
    });
    if (!reset) {
      this.getConnectors();
    }
  }

  private getKWhIndex(val: number) {
    return steps.findIndex((step) => step >= val);
  }
}
